import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'

import AppContext from '../context/AppContext';
import { useLanguageContext } from "../context/LanguageContext";
import { loadQueryString, createQueryString } from '../utils';

export default function AppProvider({ children, default_sorting }) {
  let LSSourceLangCode = localStorage.getItem('i18nextSrcLng')
  if (!LSSourceLangCode) {
    localStorage.setItem('i18nextSrcLng', 'en')
    LSSourceLangCode = localStorage.getItem('i18nextSrcLng')
  }

  const { langs_db } = useLanguageContext();

  let { search } = useLocation();
  let navigate = useNavigate();
  let curr_search = loadQueryString(search);

  // Заполняем фильтр из урла
  let _prefilter = {};
  let _prepaginator = { currentPage: 1, totalPages: 0 };
  for (const key in curr_search) {
    if (['entity', 'cpa_id'].includes(key)) {
      _prefilter[key] = { value: curr_search[key] }
    }
    if (['page'].includes(key)) {
      _prepaginator.currentPage = parseInt(curr_search[key]) || 1;
    }
  }

  const [listItems, setListItems] = useState([]);
  const [paginator, setPaginator] = useState(_prepaginator);
  const [totals, setTotals] = useState({});
  const [sorting, setSorting] = useState(default_sorting || { by: 'id', order: 'desc' });
  const [filter, setFilter] = useState(_prefilter);
  const [modal, setModal] = useState({ id: 0, link: '', title: '', show: false });
  const [loading, setLoading] = useState(false);
  const [currentLang, setCurrentLang] = useState(LSSourceLangCode);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (currentLang) {
      localStorage.setItem('i18nextSrcLng', currentLang)
    }
  }, [currentLang]);

  const setFilterUrl = (filter) => {
    setFilter(filter);
    for (const key in filter) {
      if (['entity', 'cpa_id'].includes(key)) {
        curr_search[key] = filter[key].value;
      }
    }
    for (const el of Object.keys(curr_search)) {
      if (!filter[el]) delete curr_search[el];
    }
    navigate(createQueryString(curr_search))
  }

  const setPaginatorUrl = (paginator) => {
    paginator.currentPage = parseInt(paginator.currentPage) || 1;
    setPaginator(paginator);
    curr_search.page = paginator.currentPage;
    if (paginator.currentPage == 1) delete curr_search.page;
    navigate(createQueryString({ ...curr_search }))
  }

  return (
    <AppContext.Provider value={{
      languages: langs_db,
      currentLang,
      currentLangId: (langs_db.find(x => x.code == currentLang)?.id || 1),
      setCurrentLang,

      listItems, setListItems,
      paginator, setPaginator: setPaginatorUrl,
      sorting, setSorting,
      filter, setFilter: setFilterUrl,
      modal, setModal,
      loading, setLoading,
      selected, setSelected,
      totals, setTotals
    }}>
      {children}
    </AppContext.Provider>
  );
}